import device from "current-device";

/**
 * Defines and returns an object containing various boolean properties related to the user's device and browser.
 * @returns {Object} An object with the following properties:
 *   - isIpad: A boolean indicating whether the user is using an iPad.
 *   - isMacLike: A boolean indicating whether the user is using a Mac-like device (Mac, iPhone, iPod, iPad).
 *   - isSafari: A boolean indicating whether the user is using Safari browser.
 *   - isFirefox: A boolean indicating whether the user is using Firefox browser.
 *   - isIOS: A boolean indicating whether the user is using an iOS device (iPhone, iPod, iPad).
 *   - mobile: A boolean indicating whether the user is on a mobile device.
 *   - tablet: A boolean indicating whether the user is on a tablet device.
 *   - mobileDevice: A boolean indicating whether the user is on a mobile or tablet device.
 */
const defineParams = (() => {
  const isIpad =
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);
  const isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)
    ? true
    : false || isIpad;

  // eslint-disable-next-line no-useless-escape
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  const isIOS = navigator.platform.match(/(iPhone|iPod|iPad)/i)
    ? true
    : false || isIpad;
  const mobile = device.mobile() || isIpad || device.tablet() || isIOS;
  const tablet = device.tablet() || isIpad;
  const mobileDevice = mobile || tablet || isIOS;
  return {
    isIpad,
    isMacLike,
    isSafari,
    isFirefox,
    isIOS,
    mobile,
    tablet,
    mobileDevice,
  };
})();

const setDefineParams = () => {
  for (const key in defineParams) {
    window[key] = defineParams[key];
  }
  if (defineParams.isMacLike) document.body.classList.add("isMacLike");
  if (defineParams.isSafari) document.body.classList.add("isSafari");
  if (defineParams.isFirefox) document.body.classList.add("isFirefox");
};

export { defineParams, setDefineParams };
